import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sbd_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

// public
export const sendContact = (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data);
export const getExamples = () => axios.get(`${API}/content/examples`).then((r) => r.data);
export const getReferences = () => axios.get(`${API}/content/references`).then((r) => r.data);
export const getReviews = () => axios.get(`${API}/content/reviews`).then((r) => r.data);
export const getSettings = () => axios.get(`${API}/content/settings`).then((r) => r.data);

// auth
export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const adminMe = () => axios.get(`${API}/auth/me`, auth()).then((r) => r.data);

// admin contacts
export const getAdminContacts = (params) => axios.get(`${API}/admin/contacts`, { ...auth(), params }).then((r) => r.data);
export const getContactStats = () => axios.get(`${API}/admin/contacts/stats`, auth()).then((r) => r.data);
export const updateContact = (id, body) => axios.patch(`${API}/admin/contacts/${id}`, body, auth()).then((r) => r.data);
export const deleteContact = (id) => axios.delete(`${API}/admin/contacts/${id}`, auth()).then((r) => r.data);

// admin examples
export const saveExample = (item) =>
  item.id
    ? axios.put(`${API}/admin/examples/${item.id}`, item, auth()).then((r) => r.data)
    : axios.post(`${API}/admin/examples`, item, auth()).then((r) => r.data);
export const deleteExample = (id) => axios.delete(`${API}/admin/examples/${id}`, auth()).then((r) => r.data);

// admin references
export const saveReference = (item) =>
  item.id
    ? axios.put(`${API}/admin/references/${item.id}`, item, auth()).then((r) => r.data)
    : axios.post(`${API}/admin/references`, item, auth()).then((r) => r.data);
export const deleteReference = (id) => axios.delete(`${API}/admin/references/${id}`, auth()).then((r) => r.data);

// admin settings
export const saveSettings = (body) => axios.put(`${API}/admin/settings`, body, auth()).then((r) => r.data);

// admin reviews
export const saveReview = (item) =>
  item.id
    ? axios.put(`${API}/admin/reviews/${item.id}`, item, auth()).then((r) => r.data)
    : axios.post(`${API}/admin/reviews`, item, auth()).then((r) => r.data);
export const deleteReview = (id) => axios.delete(`${API}/admin/reviews/${id}`, auth()).then((r) => r.data);

// admin image upload -> returns absolute public URL
export const uploadImage = (fileObj) => {
  const fd = new FormData();
  fd.append("file", fileObj);
  return axios
    .post(`${API}/admin/upload`, fd, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" } })
    .then((r) => `${BACKEND_URL}${r.data.url}`);
};
